import { Award, Trophy, HeartHandshake } from "lucide-react";
import { Section, SectionTitle, Reveal } from "@/components/Section";
import { useContent } from "@/i18n";
import { Shape3D } from "@/components/Objects3D";

const achievementIcons = [Trophy, Award, HeartHandshake];

export const Certificates = () => {
  const { c, ui } = useContent();
  return (
    <Section id="certificates" num="07" chapter={ui.certificates.chapter} className="bg-ivory">
      <Shape3D shape="star" blue size={48} className="absolute right-[6%] top-24 hidden md:block" duration={6} />
      <SectionTitle className="max-w-3xl">
        {ui.certificates.titleA} <span className="italic text-cobalt">{ui.certificates.titleB}</span> {ui.certificates.titleC}
      </SectionTitle>

      <div className="mt-14 grid sm:grid-cols-2 lg:grid-cols-3 gap-6">
        {c.certificates.map((cert, i) => (
          <Reveal key={cert.title} delay={0.05 * i}>
            <div
              className={`group h-full rounded-2xl border border-line bg-cream p-8 shadow-[0_16px_36px_-26px_rgba(51,38,25,0.3)] hover:-translate-y-1.5 hover:border-cobalt/60 transition-[transform,border-color] duration-500 ${i % 2 === 0 ? "-rotate-1" : "rotate-1"}`}
              data-testid={`certificate-card-${i}`}
            >
              <span className={`flex h-11 w-11 items-center justify-center rounded-full ${i % 2 === 0 ? "bg-powder" : "bg-beige"}`}>
                <Award size={18} strokeWidth={1.8} className={i % 2 === 0 ? "text-cobalt" : "text-choco"} />
              </span>
              <h3 className="mt-6 font-serif text-xl md:text-2xl tracking-tight leading-snug group-hover:text-cobalt transition-colors duration-400">
                {cert.title}
              </h3>
              <p className="mt-3 text-xs tracking-[0.2em] uppercase text-cocoa">
                {cert.issuer} · {cert.year}
              </p>
            </div>
          </Reveal>
        ))}
      </div>

      <div className="mt-16">
        <Reveal>
          <p className="text-xs tracking-[0.3em] uppercase font-bold text-cobalt">{ui.certificates.achievements}</p>
        </Reveal>
        <div className="mt-6 grid md:grid-cols-3 gap-6">
          {c.achievements.map((ach, i) => {
            const Icon = achievementIcons[i % achievementIcons.length];
            return (
              <Reveal key={ach.title} delay={0.07 * i}>
                <div className="h-full rounded-2xl bg-powder/50 border border-powder p-8" data-testid={`achievement-card-${i}`}>
                  <Icon size={22} strokeWidth={1.5} className="text-cobalt" />
                  <h3 className="mt-5 font-serif text-xl tracking-tight">{ach.title}</h3>
                  <p className="mt-3 text-sm leading-relaxed text-cocoa">{ach.detail}</p>
                </div>
              </Reveal>
            );
          })}
        </div>
      </div>
    </Section>
  );
};
